export default __webpack_public_path__ + "static/media/right-logo.c43348db.png";